import { render, staticRenderFns } from "./roomTypeList.vue?vue&type=template&id=55c1087c&scoped=true"
import script from "./roomTypeList.vue?vue&type=script&lang=js"
export * from "./roomTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c1087c",
  null
  
)

export default component.exports